module.exports = __webpack_public_path__ + "img/ico_add--or.70691895.svg";